/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 7
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest)
 *
 * [Full Setup Instructions](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/implementation/web)
 */
import * as amplitude from '@amplitude/analytics-browser';
export const ApiKey = {
    altannethelsenorgeappogweb: '13684a69779ae7ee1ee41715034cad39'
};
/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration = {
    plan: {
        version: '7',
        branch: 'main',
        source: 'web',
        versionId: '9096bee8-6e14-4207-802c-026d8c7c774d'
    },
    ...{
        ingestionMetadata: {
            sourceName: 'browser-typescript-ampli',
            sourceVersion: '2.0.0'
        }
    },
    serverZone: amplitude.Types.ServerZone.EU
};
export class Identify {
    event_properties;
    event_type = amplitude.Types.SpecialEventType.IDENTIFY;
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class AdministertTimeavtale {
    event_properties;
    event_type = 'Administert timeavtale';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class AdministrertFullmakt {
    event_properties;
    event_type = 'Administrert fullmakt';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class ApnetHovedmeny {
    event_properties;
    event_type = 'Åpnet hovedmeny';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class ApnetJournaldokument {
    event_properties;
    event_type = 'Åpnet journaldokument';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class ApnetMelding {
    event_properties;
    event_type = 'Åpnet melding';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class ApnetOppgave {
    event_properties;
    event_type = 'Åpnet oppgave';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class ApnetProvesvaranalyse {
    event_properties;
    event_type = 'Åpnet prøvesvaranalyse';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class ApnetProvesvarrapport {
    event_properties;
    event_type = 'Åpnet prøvesvarrapport';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class ApnetTimeavtale {
    event_properties;
    event_type = 'Åpnet timeavtale';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class ApnetVarsel {
    event_properties;
    event_type = 'Åpnet varsel';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class ApnetVerktoy {
    event_properties;
    event_type = 'Åpnet verktøy';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class BenyttetHjelp {
    event_properties;
    event_type = 'Benyttet hjelp';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class BruktFilter {
    event_properties;
    event_type = 'Brukt filter';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class BruktForsideflis {
    event_properties;
    event_type = 'Brukt forsideflis';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class BruktGlobalsok {
    event_properties;
    event_type = 'Brukt globalsøk';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class BruktHovedmeny {
    event_properties;
    event_type = 'Brukt hovedmeny';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class BruktLokalsok {
    event_properties;
    event_type = 'Brukt lokalsøk';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class BruktSnarvei {
    event_properties;
    event_type = 'Brukt snarvei';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class EkspandertKiOppsummering {
    event_properties;
    event_type = 'Ekspandert KI-oppsummering';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class EndretKontaktinformasjon {
    event_properties;
    event_type = 'Endret kontaktinformasjon';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class EndretPersonverninnstilling {
    event_properties;
    event_type = 'Endret personverninnstilling';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class Feilmelding {
    event_properties;
    event_type = 'Feilmelding';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class FortsattSoknadReiserefusjon {
    event_properties;
    event_type = 'Fortsatt søknad reiserefusjon';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class FullfortBestillingPasientreise {
    event_properties;
    event_type = 'Fullført bestilling pasientreise';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class FullfortEKonsultasjon {
    event_properties;
    event_type = 'Fullført e-konsultasjon';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class FullfortNyFullmakt {
    event_properties;
    event_type = 'Fullført ny fullmakt';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class FullfortOnboardingHelsenorge {
    event_properties;
    event_type = 'Fullført onboarding Helsenorge';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class FullfortProsess {
    event_properties;
    event_type = 'Fullført prosess';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class FullfortReseptfornying {
    event_properties;
    event_type = 'Fullført reseptfornying';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class FullfortSkjema {
    event_properties;
    event_type = 'Fullført skjema';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class FullfortSoknadReiserefusjon {
    event_properties;
    event_type = 'Fullført søknad reiserefusjon';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class FullfortTimebestilling {
    event_properties;
    event_type = 'Fullført timebestilling';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class GittTilbakemelding {
    event_properties;
    event_type = 'Gitt tilbakemelding';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class GittTilbakemeldingKiOppsummering {
    event_properties;
    event_type = 'Gitt tilbakemelding KI-oppsummering';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class InitiertEKonsultasjon {
    event_properties;
    event_type = 'Initiert e-konsultasjon';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class InitiertNyFullmakt {
    event_properties;
    event_type = 'Initiert ny fullmakt';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class InitiertProsess {
    event_properties;
    event_type = 'Initiert prosess';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class InitiertReseptfornying {
    event_properties;
    event_type = 'Initiert reseptfornying';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class InitiertTimebestilling {
    event_properties;
    event_type = 'Initiert timebestilling';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class KlikketElement {
    event_properties;
    event_type = 'Klikket element';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class KlikketPaSokeresultat {
    event_properties;
    event_type = 'Klikket på søkeresultat';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class KopiertBestillingPasientreise {
    event_properties;
    event_type = 'Kopiert bestilling pasientreise';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class KopiertSoknadReiserefusjon {
    event_properties;
    event_type = 'Kopiert søknad reiserefusjon';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class MellomlagretSkjema {
    event_properties;
    event_type = 'Mellomlagret skjema';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class OpprettetSnarvei {
    event_properties;
    event_type = 'Opprettet snarvei';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class PageView {
    event_properties;
    event_type = 'Page View';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class SendtMelding {
    event_properties;
    event_type = 'Sendt melding';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class SessionEnd {
    event_properties;
    event_type = 'session_end';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class SessionStart {
    event_properties;
    event_type = 'session_start';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class SettVerktoyside {
    event_properties;
    event_type = 'Sett verktøyside';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class SlettetSnarvei {
    event_properties;
    event_type = 'Slettet snarvei';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class StartetBestillingPasientreise {
    event_properties;
    event_type = 'Startet bestilling pasientreise';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class StartetChat {
    event_properties;
    event_type = 'Startet chat';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class StartetEKonsultasjon {
    event_properties;
    event_type = 'Startet e-konsultasjon';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class StartetNyFullmakt {
    event_properties;
    event_type = 'Startet ny fullmakt';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class StartetOnboardingHelsenorge {
    event_properties;
    event_type = 'Startet onboarding Helsenorge';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class StartetOppgave {
    event_properties;
    event_type = 'Startet oppgave';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class StartetProsess {
    event_properties;
    event_type = 'Startet prosess';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class StartetReseptfornying {
    event_properties;
    event_type = 'Startet reseptfornying';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class StartetSkjema {
    event_properties;
    event_type = 'Startet skjema';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class StartetSoknadReiserefusjon {
    event_properties;
    event_type = 'Startet søknad reiserefusjon';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class StartetTimebestilling {
    event_properties;
    event_type = 'Startet timebestilling';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
export class UtfortHandling {
    event_properties;
    event_type = 'Utført handling';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
const getVoidPromiseResult = () => ({ promise: Promise.resolve() });
// prettier-ignore
export class Ampli {
    disabled = false;
    amplitude;
    get client() {
        this.isInitializedAndEnabled();
        return this.amplitude;
    }
    get isLoaded() {
        return this.amplitude != null;
    }
    isInitializedAndEnabled() {
        if (!this.amplitude) {
            console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
            return false;
        }
        return !this.disabled;
    }
    /**
     * Initialize the Ampli SDK. Call once when your application starts.
     *
     * @param options Configuration options to initialize the Ampli SDK with.
     */
    load(options) {
        this.disabled = options.disabled ?? false;
        if (this.amplitude) {
            console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
            return getVoidPromiseResult();
        }
        let apiKey = null;
        if (options.client && 'apiKey' in options.client) {
            apiKey = options.client.apiKey;
        }
        else if ('environment' in options) {
            apiKey = ApiKey[options.environment];
        }
        if (options.client && 'instance' in options.client) {
            this.amplitude = options.client.instance;
        }
        else if (apiKey) {
            this.amplitude = amplitude.createInstance();
            const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
            return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
        }
        else {
            console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
        }
        return getVoidPromiseResult();
    }
    /**
     * Identify a user and set user properties.
     *
     * @param userId The user's id.
     * @param properties The user properties.
     * @param options Optional event options.
     */
    identify(userId, properties, options) {
        if (!this.isInitializedAndEnabled()) {
            return getVoidPromiseResult();
        }
        if (userId) {
            options = { ...options, user_id: userId };
        }
        const amplitudeIdentify = new amplitude.Identify();
        const eventProperties = properties;
        if (eventProperties != null) {
            for (const [key, value] of Object.entries(eventProperties)) {
                amplitudeIdentify.set(key, value);
            }
        }
        return this.amplitude.identify(amplitudeIdentify, options);
    }
    /**
     * Flush the event.
     */
    flush() {
        if (!this.isInitializedAndEnabled()) {
            return getVoidPromiseResult();
        }
        return this.amplitude.flush();
    }
    /**
     * Track event
     *
     * @param event The event to track.
     * @param options Optional event options.
     */
    track(event, options) {
        if (!this.isInitializedAndEnabled()) {
            return getVoidPromiseResult();
        }
        return this.amplitude.track(event, undefined, options);
    }
    /**
     * Administert timeavtale
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Administert%20timeavtale)
     *
     * Når innbygger velger å gjøre endringer på en timeavtale. Det kan være avlyse time, endre time, be om endring osv.
     *
     * Detaljer om endringen kan brukes til å skille mellom avbestilling, forespørsel om nytt tidspunkt, forespørsel om videotime, spørsmål til timen og bekreftelse av timen. Analyse kan brytes ned på helseregion, møteform og type timeavtale for å sammenligne hvilke former for timeadministrasjon som forekommer.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    administertTimeavtale(properties, options) {
        return this.track(new AdministertTimeavtale(properties), options);
    }
    /**
     * Administrert fullmakt
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Administrert%20fullmakt)
     *
     * Når innbygger gjennomfører en endring på en allerede opprettet fullmakt eller sletter en fullmakt.
     *
     * `objekt` brukes til å skille mellom endring og sletting, mens `fullmakttype` og `fullmakttilganger` beskriver hvilken fullmakt som ble administrert og hvilke tilganger som ble valgt. `brukerflate` viser om hendelsen ble trigget fra app, www eller tjenester, og `pagePath`, `previousPagePath`, `pageUrl` og `pageLocation` kan brukes til å plassere handlingen i navigasjonen.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    administrertFullmakt(properties, options) {
        return this.track(new AdministrertFullmakt(properties), options);
    }
    /**
     * Åpnet hovedmeny
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/%C3%85pnet%20hovedmeny)
     *
     * Trigges når en innbygger åpner hovedmenyen i appen eller på nettsiden.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    apnetHovedmeny(properties, options) {
        return this.track(new ApnetHovedmeny(properties), options);
    }
    /**
     * Åpnet journaldokument
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/%C3%85pnet%20journaldokument)
     *
     * Åpning av et journaldokument. Dokumenttypen kan brukes til å skille mellom ulike typer journalinnhold, og helseforetak kan brukes til å analysere åpningene per sykehus eller foretak.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    apnetJournaldokument(properties, options) {
        return this.track(new ApnetJournaldokument(properties), options);
    }
    /**
     * Åpnet melding
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/%C3%85pnet%20melding)
     *
     * Dette eventet settes når brukeren åpner en melding, altså ser detaljesiden for en melding / samtale.
     *
     * Eventet settes med en rekke properties som beskriver hva slags melding det dreier seg om, hvorvidt den kan besvares eller ei, hvor mange medlinger samtalen eventuelt består av, om den er lest eller ikke med mer.
     *
     * @param properties The event's properties (e.g. antallMeldinger)
     * @param options Amplitude event options.
     */
    apnetMelding(properties, options) {
        return this.track(new ApnetMelding(properties), options);
    }
    /**
     * Åpnet oppgave
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/%C3%85pnet%20oppgave)
     *
     * Settes når bruker ser på en oppgave de har fått tildelt
     *
     * Oppgaven kan også være obligatorisk eller frivillig, og fristfeltet viser om den ikke er utløpt, passert, utløpt eller uten frist, samt antall dager til frist når den finnes. OppgaveTilknytning angir om oppgaven hører til en timeavtale eller en henvisning, og brukerflate viser om handlingen skjer i app, www, tjenester eller helsenorge.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    apnetOppgave(properties, options) {
        return this.track(new ApnetOppgave(properties), options);
    }
    /**
     * Åpnet prøvesvaranalyse
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/%C3%85pnet%20pr%C3%B8vesvaranalyse)
     *
     * Når innbygger åpner detaljside av prøvesvaranalyse. En analyse kan inneholde flere prøvesvar og vise utvikling over resultater over tid.
     *
     * @param properties The event's properties (e.g. antallProvesvar)
     * @param options Amplitude event options.
     */
    apnetProvesvaranalyse(properties, options) {
        return this.track(new ApnetProvesvaranalyse(properties), options);
    }
    /**
     * Åpnet prøvesvarrapport
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/%C3%85pnet%20pr%C3%B8vesvarrapport)
     *
     * Når bruker åpner detaljside for en prøvesvarrapport. En prøvesvarrapport kan inneholde flere prøvesvar.
     *
     * @param properties The event's properties (e.g. antallProvesvar)
     * @param options Amplitude event options.
     */
    apnetProvesvarrapport(properties, options) {
        return this.track(new ApnetProvesvarrapport(properties), options);
    }
    /**
     * Åpnet timeavtale
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/%C3%85pnet%20timeavtale)
     *
     * Når bruker åpner en timeavtale for å se detaljene.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    apnetTimeavtale(properties, options) {
        return this.track(new ApnetTimeavtale(properties), options);
    }
    /**
     * Åpnet varsel
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/%C3%85pnet%20varsel)
     *
     * Bruker klikket på lenken i et varsel for å se det varselet handler om.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    apnetVarsel(properties, options) {
        return this.track(new ApnetVarsel(properties), options);
    }
    /**
     * Åpnet verktøy
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/%C3%85pnet%20verkt%C3%B8y)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    apnetVerktoy(properties, options) {
        return this.track(new ApnetVerktoy(properties), options);
    }
    /**
     * Benyttet hjelp
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Benyttet%20hjelp)
     *
     * Trigges når innbyggeren åpner en hjelpetekst, veiledning eller ber om brukerstøtte.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    benyttetHjelp(properties, options) {
        return this.track(new BenyttetHjelp(properties), options);
    }
    /**
     * Brukt filter
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Brukt%20filter)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. antallFilterresultat)
     * @param options Amplitude event options.
     */
    bruktFilter(properties, options) {
        return this.track(new BruktFilter(properties), options);
    }
    /**
     * Brukt forsideflis
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Brukt%20forsideflis)
     *
     * Gjelder navigasjon (klikk) på "fliser" (navigasjonselementer) fra forsiden.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    bruktForsideflis(properties, options) {
        return this.track(new BruktForsideflis(properties), options);
    }
    /**
     * Brukt globalsøk
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Brukt%20globals%C3%B8k)
     *
     * Når det blir gjort et globalt søk på Helsenorge.
     *
     * @param properties The event's properties (e.g. antallSokeresultat)
     * @param options Amplitude event options.
     */
    bruktGlobalsok(properties, options) {
        return this.track(new BruktGlobalsok(properties), options);
    }
    /**
     * Brukt hovedmeny
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Brukt%20hovedmeny)
     *
     * Trigges når en innbygger klikker på et menyelement i hovedmenyen for å navigere videre.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    bruktHovedmeny(properties, options) {
        return this.track(new BruktHovedmeny(properties), options);
    }
    /**
     * Brukt lokalsøk
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Brukt%20lokals%C3%B8k)
     *
     * Når det blir gjort et lokalt søk på Helsenorge.
     *
     * @param properties The event's properties (e.g. antallSokeresultat)
     * @param options Amplitude event options.
     */
    bruktLokalsok(properties, options) {
        return this.track(new BruktLokalsok(properties), options);
    }
    /**
     * Brukt snarvei
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Brukt%20snarvei)
     *
     * Når innbygger klikker/velger å navigere via en snarvei.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    bruktSnarvei(properties, options) {
        return this.track(new BruktSnarvei(properties), options);
    }
    /**
     * Ekspandert KI-oppsummering
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Ekspandert%20KI-oppsummering)
     *
     * Dette eventet settes når brukeren klikker på 'vis mer' for å se hele  KI-oppsummeringen relatert til søket de gjorde.
     *
     * @param properties The event's properties (e.g. antallSokeresultat)
     * @param options Amplitude event options.
     */
    ekspandertKiOppsummering(properties, options) {
        return this.track(new EkspandertKiOppsummering(properties), options);
    }
    /**
     * Endret kontaktinformasjon
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Endret%20kontaktinformasjon)
     *
     * Eventet settes etter vellykket oppdatering av pårørende,  arbeidsgiver eller kommunikasjonsbehov i kjernejournal.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    endretKontaktinformasjon(properties, options) {
        return this.track(new EndretKontaktinformasjon(properties), options);
    }
    /**
     * Endret personverninnstilling
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Endret%20personverninnstilling)
     *
     * Dette eventet registrerer når en bruker endrer personverninnstillingene sine på Helsenorge. Den utløses umiddelbart etter at brukeren lagrer eller bekrefter en endring i sine personvernpreferanser.
     *  Inkluderer både samtykker, reservasjoner og tilgangsbegrensninger.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    endretPersonverninnstilling(properties, options) {
        return this.track(new EndretPersonverninnstilling(properties), options);
    }
    /**
     * Feilmelding
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Feilmelding)
     *
     * Dette eventet fanger opp feilmeldinger som oppstår i brukerreisen. Det beskriver situasjoner der noe går galt eller ikke fungerer som forventet. Eventet utløses hver når en feilmelding vises til brukeren eller registreres av systemet.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    feilmelding(properties, options) {
        return this.track(new Feilmelding(properties), options);
    }
    /**
     * Fortsatt søknad reiserefusjon
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Fortsatt%20s%C3%B8knad%20reiserefusjon)
     *
     * Når innbygger velger å fortsette på en lagret søknad om reiserefusjon.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    fortsattSoknadReiserefusjon(properties, options) {
        return this.track(new FortsattSoknadReiserefusjon(properties), options);
    }
    /**
     * Fullført bestilling pasientreise
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Fullf%C3%B8rt%20bestilling%20pasientreise)
     *
     * Når innbygger fullfører bestilling av pasientreise (rekvirert).
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    fullfortBestillingPasientreise(properties, options) {
        return this.track(new FullfortBestillingPasientreise(properties), options);
    }
    /**
     * Fullført e-konsultasjon
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Fullf%C3%B8rt%20e-konsultasjon)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    fullfortEKonsultasjon(properties, options) {
        return this.track(new FullfortEKonsultasjon(properties), options);
    }
    /**
     * Fullført ny fullmakt
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Fullf%C3%B8rt%20ny%20fullmakt)
     *
     * Bruker har har opprettet en ny fullmakt.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    fullfortNyFullmakt(properties, options) {
        return this.track(new FullfortNyFullmakt(properties), options);
    }
    /**
     * Fullført onboarding Helsenorge
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Fullf%C3%B8rt%20onboarding%20Helsenorge)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    fullfortOnboardingHelsenorge(properties, options) {
        return this.track(new FullfortOnboardingHelsenorge(properties), options);
    }
    /**
     * Fullført prosess
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Fullf%C3%B8rt%20prosess)
     *
     * Fellesevent for når bruker har fullført en "mindre" prosess. Skal ikke benyttes for prosesser der det er spesifisert egne events
     *
     * I praksis brukes dette som et fellesevent for avslutning av prosesser som for eksempel endring av varselinnstillinger. Feltene tjeneste, prosessnavn og partner kan brukes til å segmentere fullføringer, mens brukerflate, pagePath og pageUrl viser hvor i løsningen hendelsen ble trigget.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    fullfortProsess(properties, options) {
        return this.track(new FullfortProsess(properties), options);
    }
    /**
     * Fullført reseptfornying
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Fullf%C3%B8rt%20reseptfornying)
     *
     * Bruker har fullført prosessen for å fornye en resept.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    fullfortReseptfornying(properties, options) {
        return this.track(new FullfortReseptfornying(properties), options);
    }
    /**
     * Fullført skjema
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Fullf%C3%B8rt%20skjema)
     *
     * Dette eventet settes når en bruker har fullført og sendt inn et skjema.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    fullfortSkjema(properties, options) {
        return this.track(new FullfortSkjema(properties), options);
    }
    /**
     * Fullført søknad reiserefusjon
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Fullf%C3%B8rt%20s%C3%B8knad%20reiserefusjon)
     *
     * Når innbygger fullfører en søknad om reiserefusjon (pasientreise).
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    fullfortSoknadReiserefusjon(properties, options) {
        return this.track(new FullfortSoknadReiserefusjon(properties), options);
    }
    /**
     * Fullført timebestilling
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Fullf%C3%B8rt%20timebestilling)
     *
     * Trigges når innbyggeren har fullført og bekreftet bestillingen av en time.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    fullfortTimebestilling(properties, options) {
        return this.track(new FullfortTimebestilling(properties), options);
    }
    /**
     * Gitt tilbakemelding
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Gitt%20tilbakemelding)
     *
     * Bruker har gittt tilbakemelding på sidens innhold, enten i form av "Fant du det du lette etter"  der de kan svare ja eller nei (property: 'tilbakemeldingTekst', eller tilbakemelding i form av at de velger et smilefjes som tilsvarer en score fra 1 til 5, der 5 er best (property: 'tilbakemeldingScore')
     *
     *
     *
     *
     *
     *
     *
     * Se komponentene i [Frankenstein](https://frankenstein.helsenorge.design/latest/komponenter/feedback-banner/bruk-9iGQGg9U)
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    gittTilbakemelding(properties, options) {
        return this.track(new GittTilbakemelding(properties), options);
    }
    /**
     * Gitt tilbakemelding KI-oppsummering
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Gitt%20tilbakemelding%20KI-oppsummering)
     *
     * Brukeren har gitt tilbakemelding på KI-oppsummeringen i form av tommel opp (bra) eller tommel ned (dårlig).
     *  Kan sees i sammenheng med utført søk.
     *
     * @param properties The event's properties (e.g. antallSokeresultat)
     * @param options Amplitude event options.
     */
    gittTilbakemeldingKiOppsummering(properties, options) {
        return this.track(new GittTilbakemeldingKiOppsummering(properties), options);
    }
    /**
     * Initiert e-konsultasjon
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Initiert%20e-konsultasjon)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    initiertEKonsultasjon(properties, options) {
        return this.track(new InitiertEKonsultasjon(properties), options);
    }
    /**
     * Initiert ny fullmakt
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Initiert%20ny%20fullmakt)
     *
     * Sporer når en bruker indikerer at de skal opprette en ny fullmakt
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    initiertNyFullmakt(properties, options) {
        return this.track(new InitiertNyFullmakt(properties), options);
    }
    /**
     * Initiert prosess
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Initiert%20prosess)
     *
     * Indicates the start of a user-initiated process or workflow within the application, capturing the moment a specific action sequence is triggered.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    initiertProsess(properties, options) {
        return this.track(new InitiertProsess(properties), options);
    }
    /**
     * Initiert reseptfornying
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Initiert%20reseptfornying)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    initiertReseptfornying(properties, options) {
        return this.track(new InitiertReseptfornying(properties), options);
    }
    /**
     * Initiert timebestilling
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Initiert%20timebestilling)
     *
     * Trigges ved første indikasjon på at innbyggeren ønsker å bestille en time.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    initiertTimebestilling(properties, options) {
        return this.track(new InitiertTimebestilling(properties), options);
    }
    /**
     * Klikket element
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Klikket%20element)
     *
     * Adhoc klikksporing på UI-elementer. Skal kun brukes for kortere perioder og ikke som konstant sporing.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    klikketElement(properties, options) {
        return this.track(new KlikketElement(properties), options);
    }
    /**
     * Klikket på søkeresultat
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Klikket%20p%C3%A5%20s%C3%B8keresultat)
     *
     * Når bruker klikker på et et søkeresultat etter at de har gjort et søk.
     *
     * Plasseringen i søkeresultatet gjør det mulig å vurdere om brukere oftere klikker på toppresultater eller lengre ned i listen. Kombinert med `sokeresultatTag` og `valgtSokeresultat` kan eventet brukes til å se hvilke typer treff og hvilke konkrete resultater som faktisk blir valgt.
     *
     * @param properties The event's properties (e.g. antallSokeresultat)
     * @param options Amplitude event options.
     */
    klikketPaSokeresultat(properties, options) {
        return this.track(new KlikketPaSokeresultat(properties), options);
    }
    /**
     * Kopiert bestilling pasientreise
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Kopiert%20bestilling%20pasientreise)
     *
     * Når innbygger velger å starte ny reisebestilling ved å opprette en kopi av tidligere bestilling av rekvirert reise. Justerer dato ++
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    kopiertBestillingPasientreise(properties, options) {
        return this.track(new KopiertBestillingPasientreise(properties), options);
    }
    /**
     * Kopiert søknad reiserefusjon
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Kopiert%20s%C3%B8knad%20reiserefusjon)
     *
     * Når innbygger velger å starte en søknad om reiserefusjon ved å kopiere en tidligere søknad og gjøre nødvendige justeringer.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    kopiertSoknadReiserefusjon(properties, options) {
        return this.track(new KopiertSoknadReiserefusjon(properties), options);
    }
    /**
     * Mellomlagret skjema
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Mellomlagret%20skjema)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    mellomlagretSkjema(properties, options) {
        return this.track(new MellomlagretSkjema(properties), options);
    }
    /**
     * Opprettet snarvei
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Opprettet%20snarvei)
     *
     * Dette eventet representerer brukerhandlingen med å opprette en snarvei i Helsenorge-appen eller på nettplattformen. Den utløses når en bruker har lagt til en ny snarvei for rask tilgang til en bestemt funksjon eller seksjon.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    opprettetSnarvei(properties, options) {
        return this.track(new OpprettetSnarvei(properties), options);
    }
    /**
     * Page View
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Page%20View)
     *
     * Sporer sidevisninger på helsenorge.no og skjermvisninger i appen.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    pageView(properties, options) {
        return this.track(new PageView(properties), options);
    }
    /**
     * Sendt melding
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Sendt%20melding)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    sendtMelding(properties, options) {
        return this.track(new SendtMelding(properties), options);
    }
    /**
     * session_end
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/session_end)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    sessionEnd(properties, options) {
        return this.track(new SessionEnd(properties), options);
    }
    /**
     * session_start
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/session_start)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    sessionStart(properties, options) {
        return this.track(new SessionStart(properties), options);
    }
    /**
     * Sett verktøyside
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Sett%20verkt%C3%B8yside)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    settVerktoyside(properties, options) {
        return this.track(new SettVerktoyside(properties), options);
    }
    /**
     * Slettet snarvei
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Slettet%20snarvei)
     *
     * Dette eventet representerer brukerhandlingen med å slette en snarvei i Helsenorge-appen eller på nettplattformen, enten ved å redigere snarveiene fra forsiden og/eller velger å "unmarke" stjernesymbolet i kontekst av tjenesten/funksjonen.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    slettetSnarvei(properties, options) {
        return this.track(new SlettetSnarvei(properties), options);
    }
    /**
     * Startet bestilling pasientreise
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Startet%20bestilling%20pasientreise)
     *
     * Når innbygger starter prosess for å bestille en pasientreise. Gjelder rekvirert reise.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    startetBestillingPasientreise(properties, options) {
        return this.track(new StartetBestillingPasientreise(properties), options);
    }
    /**
     * Startet chat
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Startet%20chat)
     *
     * Event trigges når innbygger klikker på chat-ikon, dvs. de åpner dialogvindu for chat.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    startetChat(properties, options) {
        return this.track(new StartetChat(properties), options);
    }
    /**
     * Startet e-konsultasjon
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Startet%20e-konsultasjon)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    startetEKonsultasjon(properties, options) {
        return this.track(new StartetEKonsultasjon(properties), options);
    }
    /**
     * Startet ny fullmakt
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Startet%20ny%20fullmakt)
     *
     * Bruker har startet prosessen med å opprette en ny fullmakt.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    startetNyFullmakt(properties, options) {
        return this.track(new StartetNyFullmakt(properties), options);
    }
    /**
     * Startet onboarding Helsenorge
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Startet%20onboarding%20Helsenorge)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    startetOnboardingHelsenorge(properties, options) {
        return this.track(new StartetOnboardingHelsenorge(properties), options);
    }
    /**
     * Startet oppgave
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Startet%20oppgave)
     *
     * Bruker har startet på en tildelt oppgave.
     *  Settes når bruker klikker på CTA for å starte eller fortsette på en oppgave på oppgavedetalj-siden for en uløst oppgave.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    startetOppgave(properties, options) {
        return this.track(new StartetOppgave(properties), options);
    }
    /**
     * Startet prosess
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Startet%20prosess)
     *
     * Fellesevent for når bruker har påbegynt en "mindre" selvbetjeningsprosess.
     *
     *
     * Skal ikke benyttes for prosesser med egne evnents slik som timeavtaler, fullmakt, pasientreiser og resepter.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    startetProsess(properties, options) {
        return this.track(new StartetProsess(properties), options);
    }
    /**
     * Startet reseptfornying
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Startet%20reseptfornying)
     *
     * Settes når bruker har påbegynt prosessen for å fornye en resept.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    startetReseptfornying(properties, options) {
        return this.track(new StartetReseptfornying(properties), options);
    }
    /**
     * Startet skjema
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Startet%20skjema)
     *
     * Dette eventet settes ved starten av en prosess der bruker må fylle ut et skjema.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    startetSkjema(properties, options) {
        return this.track(new StartetSkjema(properties), options);
    }
    /**
     * Startet søknad reiserefusjon
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Startet%20s%C3%B8knad%20reiserefusjon)
     *
     * Når innbygger starter prosess for å søke om refusjon av reise. Start-event skjer når rolle (dvs. hvem man søker på vegne av) blir valgt.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    startetSoknadReiserefusjon(properties, options) {
        return this.track(new StartetSoknadReiserefusjon(properties), options);
    }
    /**
     * Startet timebestilling
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Startet%20timebestilling)
     *
     * Trigges når innbyggeren starter selve flyten for å bestille en time.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    startetTimebestilling(properties, options) {
        return this.track(new StartetTimebestilling(properties), options);
    }
    /**
     * Utført handling
     *
     * [View in Tracking Plan](https://data.eu.amplitude.com/nhn/Alt%20annet%20-%20Helsenorge%20App%20og%20Web/events/main/latest/Utf%C3%B8rt%20handling)
     *
     * Samle-event. Trackes når handlingen er nyttig å måle, men ikke skal ha eget eventnavn. Innbygger gjør en aktiv handling som endrer noe, sender inn noe, setter en status/innstilling. Det er ikke ren klikksporing, men at noe endres.
     *
     * @param properties The event's properties (e.g. brukerflate)
     * @param options Amplitude event options.
     */
    utfortHandling(properties, options) {
        return this.track(new UtfortHandling(properties), options);
    }
}
export const ampli = new Ampli();
